import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const createFormResponse = (request) => {
    return vdkEmHappinessPortalApi.post('/field-responses/submit-form', request);
};
const getFormResponsesByEventId = (eventId) => {
    return vdkEmHappinessPortalApi.get(`/form-responses/event/${eventId}`);
};
const getFormResponseById = (id) => {
    return vdkEmHappinessPortalApi.get(`/form-responses/${id}`);
};
const checkEmailExists = (request) => {
    return vdkEmHappinessPortalApi.post(`/field-responses/check-email`, request);
};
const FormResponseApi = {
    createFormResponse,
    getFormResponsesByEventId,
    getFormResponseById,
    checkEmailExists
};
export default FormResponseApi;
